<div fxLayout="row" fxLayoutAlign="center center">
  <div fxLayout="row" fxFlex="100%" fxFlex.sm="80%" fxFlex.md="80%" fxFlex.xs="100%" fxLayoutAlign="center stretch"
    fxLayoutGap="20px">
    <mat-card fxLayout="row wrap" fxFlex="1000px" fxFlex.xs="100%" fxLayoutAlign="center stretch"
      class="mat-elevation-z-sides">
      <img mat-card-image name="header-course-img" class="header-img" src={{course?.iconPath}} alt={{course?.name}}>
      <mat-card-content fxFlex.xs="90%" fxFlex="70%" fxLayout="column" fxLayoutAlign="space-around stretch"
        fxLayoutGap="20px">
        <br />
        <h1 name="course-header"><b>{{course?.name}}</b></h1>

        <div class="initial-assessment-welcome">
          <h3 i18n="@@ia-user-header" name="user-header">Welcome, {{userFirstName + ' ' + userLastName}}.</h3>
          <br />

          <p i18n="@@ia-welcome-1" name="ia-welcome-1">
            Before you start your learning, you need to complete
            an initial assessment in {{course?.name}}.
          </p>
          <p i18n="@@ia-welcome-2" name="ia-welcome-1">
            The results will help us to find out what you can do
            already and where you can improve.
          </p>
        </div>

        <mat-accordion fxLayout="column" fxLayoutGap="15px" multi>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title i18n="@@ia-practice-title" name="initial-assessment-practice-title">
                <b>Try it out</b>
              </mat-panel-title>

            </mat-expansion-panel-header>
            <div class="initial-assessment-practice-desc">
              <p i18n="@@ia-practice-desc-1" name="ia-practice-desc-1">
                Work through the practice assessment first as
                this will show you how the real questions work.
              </p>
              <p i18n="@@ia-practice-desc-2" name="ia-practice-desc-2">
                Take your time and make sure you understand
                what you need to do.
              </p>
            </div>
            <div fxLayout="column" fxLayoutAlign="space-between center">
              <button i18n="@@button-launch-practice-assessment" mat-raised-button color="primary"
                name="button-launch-practice-assessment" id="btnLaunchPracticeAssessment"
                (click)="redirectToContentPlayer()">Launch Practice Assessment</button>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n="@@ia-instructions-title" name="initial-assessment-instructions-title">
                <b>Read instructions and start assessment</b>
              </mat-panel-title>

            </mat-expansion-panel-header>
            <div class="initial-assessment-instructions">
              <p i18n="@@ia-ins-prep-title" name="ia-ins-prep-title"><b>Prepare</b></p>

              <p i18n="@@ia-ins-prep-1" name="ia-ins-prep-1">You’ll need headphones if you’d like to listen to
                the questions. (You can switch sound on and off
                in audio settings.)</p>

              <p i18n="@@ia-ins-prep-2" name="ia-ins-prep-2">Press the help button to see how the different
                types of questions work – and how to change
                the way they look.</p>

              <p i18n="@@ia-ins-begin-title" name="ia-ins-begin-title"><b>Begin</b></p>

              <p i18n="@@ia-ins-begin-1" name="ia-ins-begin-1">Your assessment will have 40 or 50 questions.
                Answer each one honestly, without help from
                anyone else.</p>

              <p i18n="@@ia-ins-begin-2" name="ia-ins-begin-2">You don’t have to finish in one go – just stop
                and log out. Later, you can pick up from where
                you left off.</p>

              <p i18n="@@ia-ins-begin-3" name="ia-ins-begin-3">If you have any problems, please talk to your
                tutor.</p>

              <p i18n="@@ia-ins-remember-title" name="ia-ins-remember-title"><b>Remember</b></p>

              <p i18n="@@ia-ins-remember-1" name="ia-ins-remember-1">Once you’ve answered a question and moved on
                to the next one, you can’t go back to change
                your answer.</p>

              <p i18n="@@ia-ins-remember-2" name="ia-ins-remember-2">If you’re stuck on a question, you don’t have to
                try it straight away – leave it alone and move on.</p>

              <p i18n="@@ia-ins-remember-3" name="ia-ins-remember-3">If you do skip a question, you can go back and
                give it a go – but if you leave it blank it will be
                marked wrong.</p>

              <p i18n="@@ia-ins-finish-title" name="ia-ins-finish-title"><b>Finish</b></p>

              <p i18n="@@ia-ins-finish-1" name="ia-ins-finish-1">At the end of your assessment, you’ll see your
                results. You might want to print them out to
                keep a record.</p>

              <p i18n="@@ia-ins-finish-2" name="ia-ins-finish-2">Close your results window and you’ll see your
                learning plan. You might want to start working
                on this straight away.</p>

              <p i18n="@@ia-ins-finish-3" name="ia-ins-finish-3">Remember to log out when you’ve finished. If
                you have any queries, please talk to your tutor.</p>
            </div>
            <div fxLayout="column" fxLayoutAlign="space-between center">
              <button i18n="@@button-launch-assessment" mat-raised-button color="primary"
                name="button-launch-assessment" id="btnLaunchAssessment"
                (click)="redirectToContentPlayer(course?.initialAssessmentObjectId)" mat-button>Launch
                Assessment</button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <app-browser-note></app-browser-note>
      </mat-card-content>
    </mat-card>
  </div>
</div>